import { useSelector } from 'react-redux';
import { getName as getCountryName } from 'country-list';

import { titleByRatingType } from 'shared/constants/titleByRatingType';
import { getSubscriptionRatingsLabel } from 'shared/constants/subscriptionRatings';
import { useFetchPortfolio } from 'modules/common/GraphQL/portfolios/hooks';
import { useQuery } from 'shared/hooks';
import { useTranslation } from 'react-i18next';

export const PortfolioBreadcrumbs = ({ match }) => titleByRatingType[match.params.ratingType];

export const PortfolioDetailsBreadcrumbs = () => {
  const { singleDossier } = useSelector(({ dossier }) => dossier);

  return singleDossier ? singleDossier.name : 'Portfolio details';
};

export const PortfolioItemsBreadcrumbs = ({ match }) => {
  const { data } = useFetchPortfolio(match.params.portfolioId);

  return data?.portfolio?.name || 'Portfolio details';
};

export const CoverageListBreadcrumbs =
  (text, param, mapper) =>
  ({ match }) => {
    return `${text} - ${mapper ? mapper(match.params[param]) : match.params[param]}`;
  };

export const HomepageBreadcrumbs = () => 'PageOne';

export const RSRRatingUsersBreadcrumbs = () => {
  const { name, ratingType } = useQuery();
  return `${name || 'Rating Users'}${ratingType ? ` - ${ratingType}` : ''}`;
};

export const SubscriptionRatingsBreadcrumbs = ({ match }) =>
  getSubscriptionRatingsLabel(match.params.ratingType);

export const CoveredBondsCountryBreadcrumbs = ({ match }) => {
  const { t } = useTranslation();

  const countryName = [undefined, 'ALL', 'all'].includes(match.params.country)
    ? t('COVERED_BONDS.ALL_COUNTRIES')
    : getCountryName(match.params.country);

  return `${t('COVERED_BONDS.COVERED_BONDS')} - ${countryName}`;
};

export const CreditRatingCoverageTableCountryBreadcrumb = ({ match }) =>
  getCountryName(match.params.countryId);
